import { SupportedLanguages } from '@/types/globals';

interface LocationTerm {
  term_id: number;
  name: string;
  slug: string;
  term_group: number;
  term_taxonomy_id: number;
  taxonomy: string;
  description: string;
  parent: number;
  count: number;
  filter: string;
}

interface LocationFiltersProps {
  locationTerms: LocationTerm[];
  selectedLocation: number | null;
  onLocationChange: (locationId: number | null) => void;
  locale: SupportedLanguages;
}

const text = {
  en: {
    showAll: 'Show All',
  },
  fr: {
    showAll: 'Tout afficher',
  },
};

export function LocationFilters({
  locationTerms,
  selectedLocation,
  onLocationChange,
  locale,
}: LocationFiltersProps) {
  return (
    <div className="bg-warmgrey-900 flex flex-wrap gap-2 rounded-2xl p-2 md:rounded-full">
      <button
        onClick={() => onLocationChange(null)}
        className={`h-9 rounded-full px-4 py-1.5 text-sm font-medium transition-colors md:h-12 md:px-5 ${
          selectedLocation === null
            ? 'bg-qf-purple text-white'
            : 'hover:border-qf-purple border border-gray-300 bg-white text-gray-900'
        }`}
      >
        <span dangerouslySetInnerHTML={{ __html: text[locale].showAll }} />
      </button>
      {locationTerms.slice(0, 5).map(term => (
        <button
          key={term.term_id}
          onClick={() => onLocationChange(term.term_id)}
          className={`h-9 rounded-full px-4 py-1.5 text-sm font-medium transition-colors md:h-12 md:px-5 ${
            selectedLocation === term.term_id
              ? 'bg-qf-purple text-white'
              : 'text-qf-black hover:border-qf-purple border border-gray-300 bg-white'
          }`}
        >
          {term.name}
        </button>
      ))}
    </div>
  );
}
